import FinancialPerformance from './FinancialPerformance'
import classnames from 'classnames'
import { useEffect, useState } from 'react'
import { requestGetEnrollmentsExist } from '../../../../actions/enrollmentActions'
import { useSelector } from 'react-redux'
import { COMMON_ERRORS } from '../../../../misc/Constants'
import { toast } from 'react-toastify'
import classes from './BusinessDashboard.module.scss'

const BusinessDashboard = () => {
  const currentUser = useSelector(state => state.user.current_user)
  const [communityHasEnrollments, setCommunityHasEnrollments] = useState()
  const [loadingEnrollmentsPresence, setloadingEnrollmentsPresence] = useState(true)

  useEffect(() => {
    requestGetEnrollmentsExist(currentUser.communities[0].id)
      .then(res => {
        setCommunityHasEnrollments(res.data.exists)
        setloadingEnrollmentsPresence(false)
      })
      .catch(() => toast.error(COMMON_ERRORS[500]))
  }, [currentUser.communities])

  return (
    <main className={classnames(classes.businessDashboardContainer, 'd-flex flex-column align-items-center')}>
      <FinancialPerformance communityHasEnrollments={communityHasEnrollments} isLoadingEnrollmentsPresence={loadingEnrollmentsPresence} />
    </main>
  )
}

export default BusinessDashboard
